import React from 'react';
import CharacterInfo from './CharacterInfo';
// Subclass moved to CharacterInfo
import AbilityScores from './AbilityScores';
import Vitals from './Vitals'; // Replaces Stats
import CombatStats from './CombatStats'; // New component
import Proficiencies from './Proficiencies'; // Replaces EquippedItems
import Skills from './Skills';
import SavingThrows from './SavingThrows';
import './CharacterSheet.css';

const CharacterSheet = ({ character, updateCharacter, inventoryActions, updateProficiency }) => {
  return (
    <div className="character-sheet">
      <CharacterInfo
        name={character.name}
        class={character.class}
        level={character.level}
        background={character.background}
        race={character.race}
        alignment={character.alignment}
        character={character} // Pass full character for Subclass
        updateCharacter={updateCharacter}
      />
      {/* Subclass moved to CharacterInfo */}
      <div className="main-content">
        <div className="left-column">
          <AbilityScores
            abilityScores={character.abilityScores}
            proficiencyBonus={character.proficiencyBonus}
            updateCharacter={updateCharacter}
          />
          <div className="stat-separator"></div>
          <CombatStats
            armorClass={character.armorClass}
            initiative={character.initiative}
            speed={character.speed}
            updateCharacter={updateCharacter}
          />
        </div>
        <div className="middle-column">
          <Vitals
            hitPoints={character.hitPoints}
            hitDice={character.hitDice}
            deathSaves={character.deathSaves}
            proficiencyBonus={character.proficiencyBonus}
            updateCharacter={updateCharacter}
          />
          <Proficiencies
            proficiencies={character.proficiencies}
            updateProficiency={updateProficiency}
          />
        </div>
        <div className="right-column">
          <SavingThrows savingThrows={character.savingThrows} />
          <div className="stat-separator"></div>
          <Skills
            skills={character.skills}
            skillModifiers={character.skillModifiers}
            updateCharacter={updateCharacter}
          />
        </div>
      </div>
    </div>
  );
};

export default CharacterSheet;
